import Image from "next/image";
import { Heading } from "../atoms/Heading";
import { Paragraph } from "../atoms/Paragraph";
import { CardHero } from "../molecules/CardHero";
import { GridCardHome } from "./GridCardHome";

export type Feature = {
  id: string | number;
  iconSrc: string;
  iconHoverSrc: string;
  title: string;
  description?: string;
  href: string;
};

export type HeroData = {
  primaryTitle: string;
  secondaryTitle?: string;
  description?: string;
  imageSrc: string;
  imageAlt?: string;
  features?: Feature[];
};

type Props = {
  data: HeroData;
  className?: string;
};

export default function HomeHero({ data, className }: Props) {
  const { primaryTitle, description, imageSrc, imageAlt, features = [] } = data;

  return (
    <section className={`relative ${className ?? ""}`}>
      {/* wrapper boxed */}
      <div className="lms-container">
        <div className="py-12 grid grid-cols-1 lg:grid-cols-2 gap-5 items-center">
          {/* Colonne gauche : textes + features + CTA */}
          <div >
            <Heading as="h1" className="text-4xl lg:text-[44px]">{primaryTitle}</Heading>

            {description && <Paragraph>{description}</Paragraph>}

            <GridCardHome>
              {features.map((f) => (
                <CardHero
                  key={f.id}
                  iconSrc={f.iconSrc}
                  iconHoverSrc={f.iconHoverSrc}
                  title={f.title}
                  text={f.description ?? ""}
                  href={f.href}
                />
              ))}
            </GridCardHome>
          </div>

          {/* Colonne droite : image qui “déborde” */}
          <div className="hidden md:flex items-center justify-center lg:justify-end">
            <div className="
              relative w-full 
              lg:translate-x-6
              xl:translate-x-12
              2xl:translate-x-16
            ">
              <Image
                src={imageSrc}
                alt={imageAlt ?? ""}
                width={972}
                height={770}
                className="w-full h-auto"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
